let AuthLinksData = [{
    // "title": "Connect",
    // "route": "connect" 
// }, {
    // "title": "Disconnect",
    // "route": "disconnect"
}]

export default AuthLinksData